<template>
  <header class='header'>
    <div class='app-layout__container middle-xs'>
      <div class='row'>
        <div class='col-md-3 col-xs-12 header-logo'>
          <a
           aria-label="burger menu"
            href='#'
            class='header-burger-menu'
            @click.prevent='mobileMenuOpen'
            :class="{ 'open': isOpen }"
          >
            <div class='navicon'></div>
          </a>

          <a href='/' class='logo-link' aria-label="logo link">
            <div class='logo'>
              <span class='icon-linksift'></span>
            </div>
          </a>
        </div>

        <nav class='col-md-9 col-xs-12 end-xs middle-xs' :class="{ 'open': isOpen }">
          <ul>
            <li v-for='item in routes' :key='item.name' :class='item.class'>
              <router-link :to='item.path'>{{ item.name }}</router-link>
            </li>
            <li>
              <Identity :items="userExtras" />
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

import Identity from '@/components/Identity/Identity.vue';

export default {
  name: 'Header',
  data: function () {
    return {
      isOpen: false,
      items: [],
      userExtras: [
        {
          name: 'Admin',
          to: '/admin',
        },
      ],
      routes: [{
        name: 'Home',
        path: '/',
        class: '',
      },
      {
        name: 'Recently sifted',
        path: '/recently-sifted',
        class: '',
      },
      {
        name: 'Contact',
        path: '/contact',
        class: '',
      },
      {
        name: 'Admin',
        path: '/admin',
        class: 'only-on-mobile',
      }],
    };
  },
  components: {
    Identity,
  },
  computed: {
    ...mapGetters(['isUserLoggedIn']),
  },
  watch: {
    $route() {
      this.isOpen = false;
      document.body.classList.remove('no-scroll');
    },
  },
  methods: {
    mobileMenuOpen() {
      this.isOpen = !this.isOpen;

      if (this.isOpen && window.innerWidth <= 768) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
  },
};
</script>
